import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Trans } from '@lingui/react/macro';
import { useMemo, useState } from 'react';
import { registerSW } from 'virtual:pwa-register';

const ServiceWorkerPrompt = () => {
  const [promptOpen, setPromptOpen] = useState(false);

  const updateSW = useMemo(
    () =>
      registerSW({
        onNeedRefresh() {
          setPromptOpen(true);
        },
        onOfflineReady() {
          console.log('offline ready');
        },
      }),
    []
  );

  const handleClose = () => {
    setPromptOpen(false);
  };
  const handleRefresh = () => {
    setPromptOpen(false);
    updateSW();
  };
  /* console.log('promptOpen', promptOpen); */

  if (!promptOpen) {
    return null;
  }
  return (
    <Dialog open>
      <DialogTitle>
        <Trans>New Release Available</Trans>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Trans>A new version of this software is available. Refresh to update.</Trans>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleRefresh} variant="contained" color="primary">
          <Trans>Update</Trans>
        </Button>
        <Button onClick={handleClose}>
          <Trans>Cancel</Trans>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceWorkerPrompt;
